import { processEvent } from '../core/processEvent'

export const wordpressCartGiveawayEvents = () => {
  const sendGiftBlockSelectBtnUnselected = () => {
    processEvent({
      event: {
        eventName: 'gift_block_select_btn_unselected',
        eventParams: {},
      },
    })
  }

  const sendGiftBlockSelectBtnPartial = () => {
    processEvent({
      event: {
        eventName: 'gift_block_select_btn_partial',
        eventParams: {},
      },
    })
  }

  const sendGiftBlockSelectBtnAllSelected = () => {
    processEvent({
      event: {
        eventName: 'gift_block_select_btn_all_selected',
        eventParams: {},
      },
    })
  }

  const sendClickAccumulatedQualified = () => {
    processEvent({
      event: {
        eventName: 'click_accumulated_qualified',
        eventParams: {},
      },
    })
  }

  const sendGiftQuestionMark = () => {
    processEvent({
      event: {
        eventName: 'gift_question_mark',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupCloseBtn = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_close_btn',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupConfirmBtn = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_confirm_btn',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupQuantityPlusBtn = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_quantity_plus_btn',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupQuantityMinusBtn = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_quantity_minus_btn',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupGoCheckoutBtn = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_go_checkout_btn',
        eventParams: {},
      },
    })
  }
  const sendGiftPopupSelectNextGift = () => {
    processEvent({
      event: {
        eventName: 'gift_popup_select_next_gift',
        eventParams: {},
      },
    })
  }

  return {
    sendGiftBlockSelectBtnUnselected,
    sendGiftBlockSelectBtnPartial,
    sendGiftBlockSelectBtnAllSelected,
    sendClickAccumulatedQualified,
    sendGiftQuestionMark,
    sendGiftPopupCloseBtn,
    sendGiftPopupConfirmBtn,
    sendGiftPopupQuantityPlusBtn,
    sendGiftPopupQuantityMinusBtn,
    sendGiftPopupGoCheckoutBtn,
    sendGiftPopupSelectNextGift,
  }
}
